/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../models/account';
import '../../../../connect/v2/common/money';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "CloseAccountRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "accountId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "closeToAccountId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "CloseAccountResponse": {
                    "fields": {
                      "account": {
                        "type": ".squareup.sfs.models.Account",
                        "id": 1,
                        "rule": "optional"
                      },
                      "closeToAccountId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "closingBalanceAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "interestPaidAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "totalClosingAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 6,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CloseAccountRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CloseAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CloseAccountRequest @ squareup/sfs/external/services/account/close_account.proto at 10:1
 */
export const CloseAccountRequest = $root.lookupType('squareup.sfs.external.service.CloseAccountRequest');
fixType(CloseAccountRequest, {
  idempotencyKey: {
    required: true
  },
  accountId: {
    required: true
  },
  closeToAccountId: {
    required: true
  }
});
Builder.createAndAttachToType(CloseAccountRequest);
/**
 * SOURCE CloseAccountResponse @ squareup/sfs/external/services/account/close_account.proto at 30:1
 */
export const CloseAccountResponse = $root.lookupType('squareup.sfs.external.service.CloseAccountResponse');
fixType(CloseAccountResponse, {
  account: {
    required: true
  },
  closeToAccountId: {
    required: true
  },
  closingBalanceAmount: {
    required: true
  },
  interestPaidAmount: {
    required: true
  },
  totalClosingAmount: {
    required: true
  }
});
Builder.createAndAttachToType(CloseAccountResponse);